import React, { useContext, useEffect } from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { observer } from "mobx-react-lite";
import { Context } from '../index';
import PrivateRoute from './PrivateRoute';

// Импорты страниц
import Start from '../pages/Start';
import Login from '../pages/Login';
import Registration from '../pages/Registration';
import Orders from '../pages/Orders';
import OrderById from '../pages/OrderById';
import OrdersInWork from '../pages/OrdersInWork';
import DemandById from '../pages/DemandById';
import Receipts from '../pages/Receipts';
import CreateReceipt from '../pages/CreateReceipt';
import ChestnyZnakChecker from '../pages/ChestnyZnakChecker';

const AppRouter = () => {
    const { store } = useContext(Context);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (store.isAuth &&
            store.positionKey === 'receiver' &&
            location.pathname === '/start') {
            navigate('/receipts', { replace: true });
        }
    }, [store.isAuth, store.positionKey, location.pathname, navigate]);

    if (store.isLoading) {
        return <div>Загрузка...</div>;
    }

    return (
        <Routes>
            {/* Публичные роуты */}
            <Route path="/login" element={
                store.isAuth ? <Navigate to="/start" replace /> : <Login />
            } />
            <Route path="/registration" element={<Registration />} />

            {/* Защищённые роуты */}
            <Route element={<PrivateRoute />}>
                <Route path="/start" element={<Start />} />
                <Route path="/orders" element={<Orders />} />
                <Route path="/orders/:id" element={<OrderById />} />
                <Route path="/ordersinwork" element={<OrdersInWork />} />
                <Route path="/demand/:id" element={<DemandById />} />
                <Route path="/receipts" element={<Receipts />} />
                <Route path="/receipts/new" element={<CreateReceipt />} />
                <Route path="/receipts/:id" element={<CreateReceipt />} />
                <Route path="/chestnyznak-checker" element={<ChestnyZnakChecker />} />
            </Route>

            {/* Редиректы по умолчанию */}
            <Route path="/" element={
                store.isAuth
                    ? (store.positionKey === 'receiver'
                        ? <Navigate to="/receipts" replace />
                        : <Navigate to="/start" replace />)
                    : <Navigate to="/login" replace />
            } />
            <Route path="*" element={
                store.isAuth
                    ? (store.positionKey === 'receiver'
                        ? <Navigate to="/receipts" replace />
                        : <Navigate to="/start" replace />)
                    : <Navigate to="/login" replace />
            } />
        </Routes>
    );
};

export default observer(AppRouter);
